import PartnershipAccountPage from './PartnershipAccountPage';

export default PartnershipAccountPage;
